import { useEffect, useState } from "react";
import "./App.css";
import SideNav from "./components/SideNav";
import AppContext from "./components/contexts/AppContext";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
 
import { ModalContext } from "./components/contexts/ModalContext";
import LinkMedia from "./components/PropertyList/LinkMedia";
import PhotoOnly from "./components/Gallery/PhotoOnly";
import PhotoThumbnailModal from "./components/modal/PhotoThumbnailModal";
import PhotoThumbnail from "./components/Gallery/PhotoThumbnail";
import GuestAccessGallery from "./components/Gallery/GuestAcessGallery";

function App() { 
  const [modalData, setModalData] = useState({currentGalleryName:null})
  const [isModalOpen, setModalOpen] = useState({ type: null, isOpen: false });

  // const [crossWordData, setCrossWordData] = useState({});

   const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installable, setInstallable] = useState(false);

  useEffect(() => {
    
    const handler = (e) => {
       console.log("BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB yes")
      e.preventDefault();
      setDeferredPrompt(e);
      setInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstallClick = async () => {
    console.log("dddddd ",deferredPrompt)
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("OUT COME ",outcome)
    if (outcome === "accepted") {
      console.log("App installed");
    } else {
      console.log("User dismissed install");
    }
    setDeferredPrompt(null);
    setInstallable(false);
  };

  return (
    <div className="App" style={{ userSelect: "none" }}>
       {installable && (
         <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            height: "40%",
            background: "#fff",
            boxShadow: "0 -2px 10px rgba(0,0,0,0.2)",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            animation: "slideUp 0.3s ease-out"
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Install this App</h2>
          <button
            onClick={handleInstallClick}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              background: "#854d0e",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Install
          </button>
          <button
            onClick={() => setInstallable(false)}
            style={{
              marginTop: "10px",
              padding: "8px 16px",
              fontSize: "14px",
              background: "#ccc",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Maybe Later
          </button>
        </div>
      )}
      <AppContext>
        <ModalContext.Provider
          value={{
            
            val2: [isModalOpen, setModalOpen],
            modalData:[modalData,setModalData]
          }}
        >
         
            <Routes>
              
               
            <Route path="/:galleryId" element={<LinkMedia />} /> 
            <Route path="photos/:galleryId" element={<PhotoThumbnail />} /> 
             {/* <Route path="album2/:galleryId" element={<PhotoThumbnailModal />} /> 
              <Route path="album/:galleryId" element={<PhotoOnly />} />full photo access */}
              <Route  path="guest/galleries/:galleryId" element={<GuestAccessGallery />} /> {/*Guest photo access */}
            </Routes>
          
        </ModalContext.Provider>
      </AppContext>
    </div>
  );
}

export default App;
